module.exports = __webpack_public_path__ + "static/media/results-page-target-audience-icon.5e961aad.svg";